export function computeNextOrder(items: Array<{ order: number }>): number {
  const finite = items.map((i) => i.order).filter((n) => Number.isFinite(n))
  if (finite.length === 0) return 0
  return Math.max(...finite) + 1
}
